import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const InvoiceTrendChart = ({ data }) => {
  const months = data.map(item => item.month.substring(0, 3));

  const TotalColor = getComputedStyle(document.documentElement).getPropertyValue('--cd5').trim();
  const PaidColor = getComputedStyle(document.documentElement).getPropertyValue('--cd6').trim();
  const PendingColor = getComputedStyle(document.documentElement).getPropertyValue('--cd7').trim();
  const ToolTipBG = getComputedStyle(document.documentElement).getPropertyValue('--tooltip-bg').trim();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 1500,
      easing: 'easeOutQuart'
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
    plugins: {
      datalabels: { display: false },
      title: {
        display: false,
        text: 'Invoice Trend',
        color: 'rgb(17, 56, 5)'
      },
      legend: {
        position: 'top',
        align: 'start',
        display: false,
        labels: {
          boxWidth: 12,
          padding: 20,
          font: {
            size: 10
          },
          usePointStyle: true,
          generateLabels: (chart) => {
            // Disable click events by making all labels unclickable
            return chart.data.datasets.map((dataset, i) => ({
              text: dataset.label,
              fillStyle: dataset.backgroundColor,
              strokeStyle: dataset.borderColor,
              lineWidth: 1,
              pointStyle: 'rect',
              hidden: false,
              // Disable click events
              datasetIndex: i
            }));
          }
        },
        // Disable click events
        onClick: null,
        onHover: null,
        onLeave: null
      },
      tooltip: {
        backgroundColor: ToolTipBG,
        padding: 12,
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 13
        },
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y} Invoices`
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          display: false,
          color: 'rgba(0, 0, 0, 0.1)'
        }
      }
    }
  };

  const chartData = {
    labels: months,
    datasets: [
      {
        label: 'Total Invoice',
        data: data.map(item => item.total_invoice),
        backgroundColor: TotalColor,
        borderColor: TotalColor,
        borderWidth: 1,
        borderRadius: 5
      },
      {
        label: 'Paid',
        data: data.map(item => item.invoices_paid),
        backgroundColor: PaidColor,
        borderColor: PaidColor,
        borderWidth: 1,
        borderRadius: 5
      },
      {
        label: 'Pending',
        data: data.map(item => item.invoices_pending),
        backgroundColor: PendingColor,
        borderColor: PendingColor,
        borderWidth: 1,
        borderRadius: 5
      }
    ]
  };

  return (
    <div className="chart-container">
      <Bar data={chartData} options={options} />
    </div>
  );
};

